import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {必須入力, 日付書式, 数値範囲指定, 年書式} from '@/type/validation/validator';
import {メーカー別受入分析表出力条件型} from '@/type/custom/otaru/report/report';

export default class 小樽市立病院メーカー別受入分析表検索条件チェッカー {
  単項目チェック結果: Error[];
  相関チェック結果: Error[];

  constructor(target: メーカー別受入分析表出力条件型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
    const 対象日付範囲エラー = 対象日付範囲のFromがToより小(target);
    this.相関チェック結果 = 対象日付範囲エラー;
    const 出力対象期間年度未入力エラー = 出力対象期間年度未入力(target);
    this.相関チェック結果 = this.相関チェック結果.concat(出力対象期間年度未入力エラー);
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '出力対象開始日',
    constraints: [
      {method: 日付書式, message: '対象日付（開始日付）の書式を正しく入力してください'},
    ],
  },
  {
    name: '出力対象終了日',
    constraints: [
      {method: 日付書式, message: '対象日付（終了日付）の書式を正しく入力してください'},
    ],
  },
  {
    name: '対象年度',
    constraints: [
      {method: 年書式, message: '対象年度が不正です'},
    ],
  },
  {
    name: '順位',
    constraints: [
      {method: (value) => 数値範囲指定(value, 0, 9999), message: '順位に 0 〜 9999 の整数を入力してください'},
    ],
  },
];

function 出力対象期間年度未入力(target: メーカー別受入分析表出力条件型): Error[] {
  const errors: Error[] = [];
  if (target.期間指定方法 === '日付' && target.出力対象開始日 === null) {
    errors.push({index: 0, message: '対象日付（開始日付）を入力してください', constraint: '', name: '出力対象期間年度未入力エラー'});
  }
  if (target.期間指定方法 === '年度' && target.対象年度 === null) {
    errors.push({index: 0, message: '対象年度を入力してください', constraint: '', name: '出力対象期間年度未入力エラー'});
  }
  return errors;
}

function 対象日付範囲のFromがToより小(target: メーカー別受入分析表出力条件型): Error[] {
  const errors: Error[] = [];
  if (target.出力対象開始日 === null || target.出力対象終了日 === null) {
    return errors;
  }
  if (target.出力対象開始日.valueOf() > target.出力対象終了日.valueOf()) {
    errors.push({index: 0, message: '対象日付の範囲指定が間違っています', constraint: '', name: '対象日付範囲エラー'});
  }
  return errors;
}
